import {ActionIcon, Box, Flex, Text} from "@mantine/core";
import classes from "./KaiLogo.module.css";
import IconKAI from "../../../assets/kai-logo.svg?react";

export const KaiLogo = () => {
    return (
        <ActionIcon
            className={classes.kai}
            display="flex"
            justify="center"
            align="center"
            gap="xs"
            variant="subtle"
            size={"lg"}
            aria-label="KAI"
        >
            <IconKAI />
        </ActionIcon>
    );
};
